import { useState, useEffect, useRef } from 'react';
import { triggerOfferPdfDownload, getOfferPdfWithEdgeFunction } from '../api/offerLettersWithEdgeFunction';

export const useOfferPdf = (initialCandidateId?: string | null) => {
  const [downloading, setDownloading] = useState(false);
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [pdfError, setPdfError] = useState<string | null>(null);
  const pdfUrlRef = useRef<string | null>(null);

  const downloadOfferPdf = async (candidateId: string) => {
    setDownloading(true);
    try {
      await triggerOfferPdfDownload(candidateId);
    } catch (err: any) {
      console.error('Error downloading offer PDF:', err);
      throw err;
    } finally {
      setDownloading(false);
    }
  };

  useEffect(() => {
    // Clean up previous URL
    if (pdfUrlRef.current) {
      URL.revokeObjectURL(pdfUrlRef.current);
      pdfUrlRef.current = null;
    }

    if (!initialCandidateId) {
      setPdfUrl(null);
      return;
    }

    let isMounted = true;
    const fetchPdf = async () => {
      setPdfLoading(true);
      setPdfError(null);
      try {
        const { blob } = await getOfferPdfWithEdgeFunction(initialCandidateId);
        if (!isMounted) return;

        if (blob) {
          const url = URL.createObjectURL(blob);
          pdfUrlRef.current = url;
          setPdfUrl(url);
        }
      } catch (err: any) {
        if (isMounted) {
          setPdfError(err.message || 'Failed to load PDF');
        }
      } finally {
        if (isMounted) {
          setPdfLoading(false);
        }
      }
    };

    fetchPdf();

    return () => {
      isMounted = false;
      if (pdfUrlRef.current) {
        URL.revokeObjectURL(pdfUrlRef.current);
        pdfUrlRef.current = null;
      }
    };
  }, [initialCandidateId]);

  return { downloadOfferPdf, downloading, pdfUrl, pdfLoading, pdfError };
};
